import { CgvPageComponent } from '$pages/cgv-page/cgv-page.component';
import { ContactPageComponent } from '$pages/contact-page/contact-page.component';
import { LoginPageComponent } from '$pages/login/login-page.component';
import { UpdatePasswordPageComponent } from '$pages/update-password/update-password-page.component';
import { PaymentPageComponent } from '$pages/payment/payment.component';
import { RenewComponent } from '$pages/payment/renew/renew.component';
import { CreatePostPageComponent } from '$pages/posts/create-post-page/create-post-page.component';
import { DisplayPostPageComponent } from '$pages/posts/display-post-page/display-post-page.component';
import { PostsPageComponent } from '$pages/posts/posts-page.component';
import { SignupFinishPageComponent } from '$pages/signup/signup-finish/signup-finish.component';
import { SignupPageComponent } from '$pages/signup/signup.component';
import { ClientsComponent } from '$pages/clients/clients.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: 'login', component: LoginPageComponent },
  { path: 'update-password', component: UpdatePasswordPageComponent },
  { path: 'signup', component: SignupPageComponent },
  { path: 'signup-finish/:token', component: SignupFinishPageComponent },
  { path: 'payment', component: PaymentPageComponent },
  { path: 'renew', component: RenewComponent },
  {
    path: 'posts',
    children: [
      { path: '', component: PostsPageComponent },
      { path: 'create', component: CreatePostPageComponent },
      { path: ':id', component: DisplayPostPageComponent },
    ],
  },
  { path: 'contact', component: ContactPageComponent },
  { path: 'cgv', component: CgvPageComponent },
  { path: 'clients', component: ClientsComponent },
  { path: '', component: PostsPageComponent},
];

@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
